<template>
	<div class="flex flex-row items-center">
		<h-switch
			v-model="isChecked"
			as="div"
			class="mr-sm flex h-lg w-16 shrink-0 cursor-pointer items-center rounded-full shadow-inner transition-colors duration-200"
			:class="{
				'bg-black': isChecked,
				'bg-gray-100': !isChecked,
			}"
		>
			<span
				class="size-6 rounded-full bg-white shadow-lg transition duration-200 ease-in-out"
				:class="{
					'translate-x-8': isChecked,
					'translate-x-1': !isChecked,
				}"
			/>
		</h-switch>

		<span>{{ label }}</span>
	</div>
</template>

<script setup lang="ts">
import {useVModel} from "@vueuse/core";

const properties = defineProps<{
	modelValue?: boolean;
	label?: string | undefined;
}>();

const emit = defineEmits<{
	(event: "update:modelValue", value: boolean): void;
}>();

const isChecked = useVModel(properties, "modelValue", emit);
</script>
